import React, { FC, Fragment } from 'react';

type Props = {
  name: string;
  value: string;
  id: string;
  text: string;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  controlled?: boolean;
  labelClassNames?: string;
};

const SegmentedRadioButton: FC<Props> = (props) => {
  const {
    name,
    value,
    id,
    text,
    checked,
    defaultChecked,
    disabled,
    controlled,
    labelClassNames
  } = props;

  const labelClass = `btn btn-default-outline${disabled ? ' disabled' : ''} ${labelClassNames || ''}`;
  const checkedProps = controlled ? { checked, readOnly: true } : { defaultChecked };

  return (
    <Fragment>
      <input
        type="radio"
        value={value}
        name={name}
        id={id}
        disabled={disabled}
        {...checkedProps}
      />
      <label className={labelClass} htmlFor={id}>
        {text}
      </label>
    </Fragment>
  );
};

export default SegmentedRadioButton;
